import { useHttpClient } from '@hakimo-ui/hakimo/util';
import { useMutation } from 'react-query';
import { ABFeedbackItem } from './useABFeedbacks';

export interface ExportAllFeedbacksResponse {
  items: ABFeedbackItem[];
  total_count: number;
}

export function useExportAllFeedbacks() {
  const httpClient = useHttpClient();

  return useMutation<ExportAllFeedbacksResponse, Error>(async () => {
    const request = new Request('/v2/orm/ab/feedback/export-all', {
      method: 'GET',
    });

    return httpClient<ExportAllFeedbacksResponse>(request, {
      responseModifier: async (response) => {
        const respJson = await response.json();
        return respJson.payload;
      },
    });
  });
}

export default useExportAllFeedbacks;
